module.exports = __webpack_public_path__ + "media/assets/icons/mirror-e7671ef6fe5ea7b16b261ba600ebc1c0.png";